import { makeThemedStyles } from "qpr-base/viewcomponents/utils";

const useExportDashboardPopUpStyles = makeThemedStyles(
  "Toolbar.ExportDashboardPopUp",
  (theme) => ({
    root: {},
    paper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      gap: "10px",
      borderRadius: "1em",
      border: "1px solid #fafafa",
      backgroundColor: "#fff",
      color: "rgba(76,81,87, 0.8)",
      fontSize: "1.6em",
      paddingTop: "0.8em",
      paddingBottom: "0.5em",
      textTransform: "uppercase",
      fontWeight: 500,
      minWidth: "170px",
      marginTop: "16px",
      overflowX: "unset",
      overflowY: "unset",
      "&::after": {
        content: '""',
        height: "0px",
        width: "0px",
        position: "absolute",
        left: "calc(50% - 15px)",
        borderRight: "solid 15px transparent",
        borderLeft: "solid 15px transparent",
        borderBottom: "solid 15px white",
        top: "-15px",
      },
    },
  })
);

export default useExportDashboardPopUpStyles;
